<template>
	<div class="prog_reg-steps theme-darkgray">
		<div class="container">
			<div class="prog_reg-steps-menu">
				<div v-swiper:menuSwiper="swiperOptions">
					<div class="swiper-wrapper">
						<div class="swiper-slide">
							<button
								class="step disable"
								:class="{
									active: step == 1,
									ready: isValidateStep(formId, 1),
									'not-ready': isValidateStep(formId, 1) === false
								}"
								@click="onClickStep(1)"
							>
								<span class="digit">1</span>
								<div class="description">
									Выбор
									<br>цены
								</div>
							</button>
						</div>
						<div class="swiper-slide">
							<button
								class="step"
								:class="{
									active: step == 2,
									disabled: isDisabled(2),
									ready: isValidateStep(formId, 2),
									'not-ready': isValidateStep(formId, 2) === false
								}"
								@click="onClickStep(2)"
							>
								<span class="digit">2</span>
								<div class="description">
									Общая
									<br>информация
								</div>
							</button>
						</div>

						<div class="swiper-slide">
							<button
								class="step"
								:class="{
									active: step == 3,
									disabled: isDisabled(3),
									ready: isValidateStep(formId, 3),
									'not-ready': isValidateStep(formId, 3) === false
								}"
								@click="onClickStep(3)"
							>
								<span class="digit">3</span>
								<div v-if="!formData.reverse_step_4" class="description">
									Выбор способа
									<br>оплаты
								</div>
								<div v-else class="description">
									Подача
									<br>документов
								</div>
							</button>
						</div>

						<div v-if="!formData.disable_step_4" class="swiper-slide">
							<button
								class="step"
								:class="{
									active: step == 4,
									disabled: isDisabled(4),
									ready: isValidateStep(formId, 4),
									'not-ready': isValidateStep(formId, 4) === false
								}"
								@click="onClickStep(4)"
							>
								<span class="digit">4</span>
								<div v-if="formData.reverse_step_4" class="description">
									Выбор способа
									<br>оплаты
								</div>
								<div v-else class="description">
									Подача
									<br>документов
								</div>
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>

</template>

<script>
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper';
import { mapGetters } from 'vuex';
import { ACTION_SET_STEP_AND_SYNC_FORM, CHECKOUT_STORE_NAMESPACE } from '@/store/checkout';

export default {
	name: 'Steps',
	components: {
		Swiper,
		SwiperSlide,
	},
	directives: {
		swiper: directive,
	},
	props: {
		formId: {
			type: Number,
			default: null,
		},
		formData: {
			type: Object,
			default: {},
		},
	},
	data() {
		return {
			swiperOptions: {
				slidesPerView: 'auto',
				spaceBetween: 0,
				initialSlide: 0, // Номер шага от 0 (default: 0)
				// cssMode: true,
				// freeMode: true,
				loop: false,
			},
		};
	},
	computed: {
		step() {
			return this.$store.getters['checkout/getStep'](this.formId);
		},
		...mapGetters({
			isValidateStep: 'checkout/isValidateStep',
			getIsInvoiceCreated: 'checkout/getIsInvoiceCreated',
		}),
	},
	methods: {
		onClickStep(step) {
			if (this.isDisabled(step)) return;
			this.$nextTick(() => this.$emit('clickStep', step));
		},
		isDisabled(step) {
			/** После создания инвойса человек не может просто так переходить между шагами */
			if (this.getIsInvoiceCreated(this.formId)) {
				return true;
			}

			for (let i = 1; i < step; i++) {
				if (!this.isValidateStep(this.formId, i)) return true;
			}
			return false;
		},
	},
};
</script>

<style lang="scss" scoped>
	.prog_reg-steps {
		position: absolute;
		z-index: 10;
		top: 0;
		left: 0;
		right: 0;
	}
	.prog_registration .prog_reg-steps-menu .step {
		height: 100% !important;
	}
</style>
